import { TabsNavStyle } from "../../Theme";
import { ProfileNavLinks } from "../Content";
import MenuList from "@mui/material/MenuList";
import { NavLink } from "react-router-dom";

export default function ProfileTabsNav(props: any) {
  return (
    <TabsNavStyle>
      <MenuList>
        {ProfileNavLinks.map((navlink, index) => {
          return (
            <NavLink
              className={
                "MuiMenuItem-root MuiMenuItem-gutters MuiButtonBase-root  "
              }
              key={index}
              to={navlink?.path}
            >
              {navlink.name}
            </NavLink>
          );
        })}
      </MenuList>
    </TabsNavStyle>
  );
}
